export function findListItemRole(entity, condition) {
    return findByName(entity?.Roles, "role.list-child", condition)
}

export function findTopbarSetting(entity, condition) {
    return findByName(entity?.Settings, "settings.topbar-settings", condition)
}

export function findByName(list, name, condition) {
    return findByCondition(list, item => item.strapi_component === name && (condition ? condition(item) : true))
}

export function findByCondition(list, condition) {
    return list?.find(condition)
}

/**
 * Finds an entity by its numCode.
 * @param {Entity[]} entities
 * @param {number} numCode
 * @param {string?} locale
 * @returns {Entity|null}
 */
export function findByNumCode(entities, numCode, locale) {
    return entities.find(entity => {
        return (!locale || entity.locale === locale) && entity.Roles.some(role => role.numCode === numCode || parseInt(role.numCode) === parseInt(numCode));
    }) || null;
}

/**
 * @typedef {Object} Entity
 * @property {string} id
 * @property {string} identifier
 * @property {Roles: { numCode?: number, strapi_component: string }?}[];
 * @property {string} locale
 * @property {string?} title
 * @property {string?} shortDesc
 * @property {Entity[]?} strapiChildren
 */
export class EntityRepository {
    /**
     * @constructor
     * @param {Entity[]} entities
     */
    constructor(entities) {
        this.entities = entities
    }

    /**
     * Finds an entity by its numCode.
     * @param {number} numCode
     * @param {string?} locale
     * @returns {Entity|null}
     */
    findByNumCode(numCode, locale) {
        return findByNumCode(this.entities, numCode, locale)
    }

    /**
     * Finds an entity by its ID.
     * @param {string} id - The ID of the entity to find.
     * @returns {Entity|null} - The entity with the given ID, or null if not found.
     */
    findById(id) {
        return this.entities.find(e => e.id === id || e.id === "Entities_" + id) || null
    }

    /**
     * Finds an entity by its identifier.
     * @param {string} identifier - The identifier of the entity to find.
     * @param locale
     * @param defaultLocale
     * @returns {Entity|null} - The entity with the given ID, or null if not found.
     */
    findByIdentifier(identifier, locale, defaultLocale) {
        const entitiesMatchingIdentifier = this.entities.filter(e => e.identifier === identifier)
        const entityMatchingLocale = entitiesMatchingIdentifier?.find(e => e.locale === locale)
        if(entityMatchingLocale) {
            return entityMatchingLocale
        } else {
            if (defaultLocale) {
                return entitiesMatchingIdentifier?.find(e => e.locale === defaultLocale)
            }
            if(entitiesMatchingIdentifier.length > 0) {
                return entitiesMatchingIdentifier[0]
            }
        }
    }
}
